/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IDiyPage {
  pageHeading?: string;
  pageImage?: string;
  pageText?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class DiyActivity extends Component {
  private readonly diyPage: IDiyPage = {
    pageHeading: 'no-sew superhero cape',
    pageImage:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/fnqzbfjwxg/imageFileData/MDq1k',
    pageText:
      'You might know that kids have superhero powers. Able to leap kinda-tall furniture in a single bound and all that. So, without any sewing, we’ll show you how to make a cape that’s worthy of their actions. Yes, an ordinary t-shirt is now the stuff of superheroes!',
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12'>
            <h1 className='page-heading'>{this.diyPage.pageHeading}</h1>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-image'>
              <img
                className='img-responsive'
                src={this.diyPage.pageImage}
                alt={this.diyPage.pageHeading}
              />
            </div>
          </div>
          <div className='col-lg-12 col-md-12'>
            <div className='diy-page-text'>
              <p>{this.diyPage.pageText}</p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default DiyActivity;
